module.exports = __webpack_public_path__ + "static/img/1.56765b1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tiankeng/1.jpg
// module id = FpyL
// module chunks = 1